<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">

                        <b-tabs class="gridtabs" v-model="tabindex">
                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-repeat text-primary mr-1"></i>
                                        Amend
                                        <b-badge id="selection" variant="primary" class="edit_tab">
                                            {{ selection.length }}</b-badge>
                                        <b-tooltip target="selection" placement="bottom">{{ selection.length }}
                                            transaction(s)
                                            selected</b-tooltip>
                                    </div>

                                </template>

                                <p class="mt-2">

                                    <b-row class="my-2">
                                        <b-col cols="12" sm="6" md="4">
                                            <b-form-group label-cols="12" label="Change Date" label-size="sm">
                                                <!-- <b-input-group>
                                                    <v-date-picker v-model="date_at" mode="date" is24hr color="green"
                                                        :locale="'en-gb'" class="form-control form-control-sm">
                                                        <template v-slot="{ inputValue, inputEvents }">
                                                            <input class="
                                                                    h-19px
                                                                    border-none
                                                                    focus:outline-none focus:border-primary
                                                                    text-primary
                                                                    " :value="inputValue" v-on="inputEvents" />
                                                        </template>
                                                    </v-date-picker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" squared variant="outline-secondary"
                                                            :disabled="!date_at" @click="date_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group> -->

                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm"
                                                        ref="date_at" v-model="date_at" :opens="'right'"
                                                        :locale-data="locale_data" :ranges="false" :showDropdowns="true"
                                                        :linkedCalendars="true" :single-date-picker="'true'">
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary" @click="date_at = {
                                                            startDate: null,
                                                            endDate: null,
                                                        }
                                                            ">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="8">
                                            <b-form-group label-cols="12" label="Change Reason?" label-for="reasontype">
                                                <!-- <b-form-radio-group class="mt-1 z-0" v-model="reasontype"
                                                    :options="options_reasontype" :aria-describedby="ariaDescribedby"
                                                    name="options_reasontype">
                                                </b-form-radio-group>
                                             -->
                                                <b-form-checkbox-group class="mt-1" v-model="reasontype"
                                                    :options="options_reasontype" :aria-describedby="ariaDescribedby"
                                                    name="options_reasontype"
                                                    @change="reasontype_change"></b-form-checkbox-group>
                                            </b-form-group>
                                        </b-col>


                                    </b-row>



                                    <b-row class="mt-2">
                                        <b-col cols="12" sm="4">
                                            <b-form-group label-cols="12" label="Ticket(s) selected" label-size="sm"
                                                class="mb-0">

                                                <b-input-group>
                                                    <b-form-tags input-id="ticketno" v-model="ticketno"
                                                        tag-variant="primary" separator=" ,;" placeholder="" size="sm"
                                                        class="h-29" add-button-text="+" add-on-change remove-on-delete
                                                        add-button-variant="outline-primary"
                                                        :disabled="true"></b-form-tags>

                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="ticketno = null" :disabled="true">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>



                                        </b-col>
                                    </b-row>

                                </p>

                            </b-tab>

                            <b-tab v-if="reasontype.includes('client')">
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Client/Supplier</template>
                                <p class="pt-3 px-0">
                                    <b-row class="mb-3"><b-col>
                                            All transactions in the selection will be updated with the following Your
                                            Ref/PO, SL
                                            A/C, Event and BL A/C if you post the change.
                                        </b-col>

                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Your Ref / PO" label-for="yourref" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="yourref"
                                                        placeholder="Your Ref / PO" size="sm"
                                                        :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="yourref = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="slac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Event" label-size="sm">
                                                <treeselect placeholder="Select event..." v-model="eventcode"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                                    searchPromptText="Type at least 4 chars..." :show-count="true"
                                                    :flatten-search-results="true" :disable-branch-nodes="true"
                                                    :matchKeys="['id']" search-nested :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="blac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="4" md="3">
                                            <b-form-group label-cols="12" label="DateTravel" label-size="sm">
                                                <b-input-group>
                                                    <daterangepicker style="width:auto !important" size="sm" ref="travelat"
                                                        v-model="travel_at" :opens="'right'"
                                                        :single-date-picker="'single'" :locale-data="{
                                                            direction: 'ltr',
                                                            format: 'dd/mm/yy',
                                                            daysOfWeek: [
                                                                'Sun',
                                                                'Mon',
                                                                'Tue',
                                                                'Wed',
                                                                'Thu',
                                                                'Fri',
                                                                'Sat',
                                                            ],
                                                            monthNames: [
                                                                'January',
                                                                'February',
                                                                'March',
                                                                'April',
                                                                'May',
                                                                'June',
                                                                'July',
                                                                'August',
                                                                'September',
                                                                'October',
                                                                'November',
                                                                'December',
                                                            ],
                                                            firstDay: 1,
                                                        }" :ranges="false" :showDropdowns="true" :linkedCalendars="true"
                                                       >
                                                    </daterangepicker>
                                                    <b-input-group-append>
                                                        <b-button size="sm" variant="outline-secondary"
                                                            @click="travel_at = null">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>

                                            </b-form-group>
                                        </b-col>

                                    </b-row>


                                </p>
                            </b-tab>

                        </b-tabs>

                    </b-card-body>
                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left mr-4">
                                <b-button squared size="sm" variant="primary" @click="saveit()"
                                    v-if="tabindex != 0 && user.permissions.includes('boughtledger.save')">
                                    <i class="fa fa-check"></i>
                                    Post It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>

                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "BLAmend",
    async mounted() {
        await this.accessdenied();
    },
    data() {
        return {
            busy: false,
            tabindex: 0,
            debounce: 500,
            readonly: false,
            ticketno: [],
            date_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            yourref: null,
            slac: null,
            blac: null,
            eventcode: null,
            travel_at: {
                startDate: null,
                endDate: null,
            },
            surname: null,
            firstname: null,
            title: null,
            passenger: null,
            reason: null,
            reasontype: [],
            options_reasontype: [
                // { text: 'Void', value: 'void', },
                { text: 'Client/Supplier', value: 'client' },
                // { text: 'Name Change', value: 'namechange', },
            ],

        };
    },
    watch: {
        surname: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.passenger = newVal + "/" + this.firstname
            },
        },
        firstname: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.passenger = this.surname + "/" + newVal
            },
        },
    },
    methods: {
        async accessdenied() {

        },
        async load() {
            this.ticketno = []

            for (var i = 0; i < this.selection.length; ++i) {
                this.ticketno.push(this.selection[i].ticketno)
            }
        },
        async reasontype_change(v) {
            console.log('reasontype_change', v)
        },

        async saveit() {
            this.busy = true;

            let variables = {}
            let rows = []

            let operation = this.reasontype[this.tabindex - 1]

            switch (operation) {


                case "client":
                    for (var j = 0; j < this.selection.length; j++) {
                        let row = {
                            id: this.selection[j].id,
                            yourref: this.yourref,
                            slac: this.slac,
                            blac: this.blac,
                            eventcode: this.eventcode,
                        }
                        if (this.travel_at.startDate) {
                            row.datetravel = this.$moment(this.travel_at.startDate).utc(true).format("YYYY-MM-DD")
                        }
                        rows.push(row);
                    }
                    variables.rows = rows
                    break;
            }

            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
                    mutation BL_save($rows: [BLTransaction_input]) {
                        BL_save(rows: $rows) {
                                    id
                                }
                        }
                            `,
                    variables,
                });
                this.message = "<span class='text-primary'>Posted it.</span>";

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;
        },

    },
};
</script>